export function transformMarketsUIToModel(value: string): string[] {
  return value ? [value] : [];
}

export function transformMarketsModelToUI(value: string[]): string {
  return value[0] || '';
}
